import type { PrivilegeDefinition } from '@/core/be/security/SecurityTypes';
import type { FeatureModule } from '@/core/platform/features/FeatureModule';

export const MindmapPrivilegeIds = {
  create: 'mindmap:create',
  edit: 'mindmap:edit',
} as const;

const MindmapPrivileges: PrivilegeDefinition[] = [
  {
    id: MindmapPrivilegeIds.create,
    scope: 'vault',
    feature: 'mindmap',
    description: 'Create new mind maps.',
  },
  {
    id: MindmapPrivilegeIds.edit,
    scope: 'vault',
    feature: 'mindmap',
    description: 'Edit existing mind maps.',
  },
];

export class MindmapFeatureModule {
  private static readonly definition: FeatureModule = {
    name: 'mindmap',
    privileges: MindmapPrivileges,
  };

  private constructor() {}

  public static getDefinition(): FeatureModule {
    return MindmapFeatureModule.definition;
  }
}
